"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const rowsEn = [
  { criterion: "Storm protection 24/7", impact: true, shutters: false },
  { criterion: "Daily aesthetics", impact: true, shutters: false },
  { criterion: "Lower up-front cost", impact: false, shutters: true },
  { criterion: "Maximum insurance discount", impact: true, shutters: false },
  { criterion: "Highest resale value", impact: true, shutters: false },
  { criterion: "Lifetime warranty", impact: true, shutters: false },
];

const rowsEs = [
  { criterion: "Protección contra tormentas 24/7", impact: true, shutters: false },
  { criterion: "Estética diaria", impact: true, shutters: false },
  { criterion: "Menor costo inicial", impact: false, shutters: true },
  { criterion: "Máximo descuento de seguro", impact: true, shutters: false },
  { criterion: "Mayor valor de reventa", impact: true, shutters: false },
  { criterion: "Garantía de por vida", impact: true, shutters: false },
];

export default function ScorecardFinale() {
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";
  const rows = isEs ? rowsEs : rowsEn;
  const impactScore = rows.filter((r) => r.impact).length;
  const shuttersScore = rows.filter((r) => r.shutters).length;

  return (
    <section className="bg-[#fefce8] py-12 rounded-2xl border-2 border-[#fbbf24] my-12">
      <h2 className="text-3xl font-bold text-[#064e3b] text-center mb-8">
        {t("blog.shutters.scorecardHeading")}
      </h2>

      <div className="overflow-x-auto px-4">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-[#064e3b]/20">
              <th className="px-4 py-3 text-left font-bold text-[#064e3b]">{t("blog.shutters.criterionHeader")}</th>
              <th className="px-4 py-3 text-center font-bold text-[#047857]">{t("blog.shutters.impactHeader")}</th>
              <th className="px-4 py-3 text-center font-bold text-[#ea580c]">{t("blog.shutters.shuttersHeader")}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.criterion} className="border-b border-[#064e3b]/10">
                <td className="px-4 py-3 font-medium text-[#064e3b]">{row.criterion}</td>
                <td className="px-4 py-3 text-center">
                  {row.impact ? (
                    <span className="text-[#047857] font-bold text-lg">&#10003;</span>
                  ) : (
                    <span className="text-[#ea580c] font-bold text-lg">&#10007;</span>
                  )}
                </td>
                <td className="px-4 py-3 text-center">
                  {row.shutters ? (
                    <span className="text-[#047857] font-bold text-lg">&#10003;</span>
                  ) : (
                    <span className="text-[#ea580c] font-bold text-lg">&#10007;</span>
                  )}
                </td>
              </tr>
            ))}
            <tr className="bg-[#fbbf24]/20 font-bold">
              <td className="px-4 py-3 text-[#064e3b]">{t("blog.shutters.totalLabel")}</td>
              <td className="px-4 py-3 text-center text-[#047857]">{impactScore}</td>
              <td className="px-4 py-3 text-center text-[#ea580c]">{shuttersScore}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}